/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateNewsArticleAttachmentDTO } from '../dto';
// @ts-ignore
import { CreateNewsArticleDTO } from '../dto';
// @ts-ignore
import { IdentifierDTO } from '../dto';
// @ts-ignore
import { NewsArticleConfirmationsListDTO } from '../dto';
// @ts-ignore
import { NewsArticleDTO } from '../dto';
// @ts-ignore
import { NewsArticleRecipientsListDTO } from '../dto';
// @ts-ignore
import { NewsArticlesListDTO } from '../dto';
// @ts-ignore
import { NewsReactionCreateDTO } from '../dto';
// @ts-ignore
import { NewsReactionDTO } from '../dto';
// @ts-ignore
import { NewsReactionDeleteDTO } from '../dto';
// @ts-ignore
import { NewsReactionListDTO } from '../dto';
// @ts-ignore
import { SetNewsArticleStatusDTO } from '../dto';
// @ts-ignore
import { UpdateNewsArticleDTO } from '../dto';
// @ts-ignore
import { UploadLinkDTO } from '../dto';
// @ts-ignore
import { ValidationErrorResponseDTO } from '../dto';
/**
 * NewsApi - axios parameter creator
 * @export
 */
export const NewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add an attachment to a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {CreateNewsArticleAttachmentDTO} createNewsArticleAttachmentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachment: async (tenantId: string, articleId: string, createNewsArticleAttachmentDTO: CreateNewsArticleAttachmentDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('addAttachment', 'tenantId', tenantId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('addAttachment', 'articleId', articleId)
            // verify required parameter 'createNewsArticleAttachmentDTO' is not null or undefined
            assertParamExists('addAttachment', 'createNewsArticleAttachmentDTO', createNewsArticleAttachmentDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles/{articleId}/attachments`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNewsArticleAttachmentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a new news article
         * @param {string} tenantId 
         * @param {CreateNewsArticleDTO} createNewsArticleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArticle: async (tenantId: string, createNewsArticleDTO: CreateNewsArticleDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createArticle', 'tenantId', tenantId)
            // verify required parameter 'createNewsArticleDTO' is not null or undefined
            assertParamExists('createArticle', 'createNewsArticleDTO', createNewsArticleDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNewsArticleDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a reaction on an article
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {NewsReactionCreateDTO} newsReactionCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArticleReaction: async (tenantId: string, employeeId: string, articleId: string, newsReactionCreateDTO: NewsReactionCreateDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createArticleReaction', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createArticleReaction', 'employeeId', employeeId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('createArticleReaction', 'articleId', articleId)
            // verify required parameter 'newsReactionCreateDTO' is not null or undefined
            assertParamExists('createArticleReaction', 'newsReactionCreateDTO', newsReactionCreateDTO)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/news/articles/{articleId}/reactions`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newsReactionCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a presigned upload link for a news article attachment
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttachmentUploadLink: async (tenantId: string, articleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createAttachmentUploadLink', 'tenantId', tenantId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('createAttachmentUploadLink', 'articleId', articleId)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles/{articleId}/attachments/createUploadLink`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a form POST upload link for uploading the benefit image. Refer to https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-post-example.html on how to implement the form POST.
         * @summary create a presigned upload link
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadLink: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createUploadLink', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles/createUploadLink`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticle: async (tenantId: string, articleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteArticle', 'tenantId', tenantId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('deleteArticle', 'articleId', articleId)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles/{articleId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a reaction on an article
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {NewsReactionDeleteDTO} newsReactionDeleteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticleReaction: async (tenantId: string, employeeId: string, articleId: string, newsReactionDeleteDTO: NewsReactionDeleteDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteArticleReaction', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteArticleReaction', 'employeeId', employeeId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('deleteArticleReaction', 'articleId', articleId)
            // verify required parameter 'newsReactionDeleteDTO' is not null or undefined
            assertParamExists('deleteArticleReaction', 'newsReactionDeleteDTO', newsReactionDeleteDTO)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/news/articles/{articleId}/reactions`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newsReactionDeleteDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an attachment from a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment: async (tenantId: string, articleId: string, attachmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('deleteAttachment', 'tenantId', tenantId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('deleteAttachment', 'articleId', articleId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('deleteAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles/{articleId}/attachments/{attachmentId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary expire a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireNewsArticle: async (tenantId: string, articleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('expireNewsArticle', 'tenantId', tenantId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('expireNewsArticle', 'articleId', articleId)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles/{articleId}/expire`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns news article confirmation list in CSV format
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportNewsArticleConfirmation: async (tenantId: string, articleId: string, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('exportNewsArticleConfirmation', 'tenantId', tenantId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('exportNewsArticleConfirmation', 'articleId', articleId)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles/{articleId}/export/csv`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a certain news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {boolean} [withImage] if true, imageURL will be populated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticle: async (tenantId: string, articleId: string, withImage?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getArticle', 'tenantId', tenantId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getArticle', 'articleId', articleId)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles/{articleId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (withImage !== undefined) {
                localVarQueryParameter['withImage'] = withImage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get reactions for an article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {string} [filter] Search by employee name, email or employee number
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleReactions: async (tenantId: string, articleId: string, filter?: string, page?: number, pageSize?: number, sortBy?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getArticleReactions', 'tenantId', tenantId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getArticleReactions', 'articleId', articleId)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles/{articleId}/reactions`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all reactions for an article
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleReactionsUnpaginated: async (tenantId: string, employeeId: string, articleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getArticleReactionsUnpaginated', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getArticleReactionsUnpaginated', 'employeeId', employeeId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getArticleReactionsUnpaginated', 'articleId', articleId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/news/articles/{articleId}/reactions/getAllReactions`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a certain news article with NewsArticleEmployeeStatus
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {boolean} [withImage] if true, imageURL will be populated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleWithEmployeeStatus: async (tenantId: string, employeeId: string, articleId: string, withImage?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getArticleWithEmployeeStatus', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getArticleWithEmployeeStatus', 'employeeId', employeeId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getArticleWithEmployeeStatus', 'articleId', articleId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/news/articles/{articleId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (withImage !== undefined) {
                localVarQueryParameter['withImage'] = withImage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all news article confirmations for tenant
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listArticleConfirmations: async (tenantId: string, articleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listArticleConfirmations', 'tenantId', tenantId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('listArticleConfirmations', 'articleId', articleId)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles/{articleId}/confirmations`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all news article recipients for tenant
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listArticleRecipients: async (tenantId: string, articleId: string, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listArticleRecipients', 'tenantId', tenantId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('listArticleRecipients', 'articleId', articleId)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles/{articleId}/recipients`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all news articles for tenant
         * @param {string} tenantId 
         * @param {'ACTIVE' | 'DRAFT' | 'EXPIRED'} [status] 
         * @param {boolean} [withImage] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listArticles: async (tenantId: string, status?: 'ACTIVE' | 'DRAFT' | 'EXPIRED', withImage?: boolean, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listArticles', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (withImage !== undefined) {
                localVarQueryParameter['withImage'] = withImage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all news articles for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listArticlesByEmployee: async (tenantId: string, employeeId: string, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listArticlesByEmployee', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('listArticlesByEmployee', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/news/articles`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary creates articleEmployee status
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {SetNewsArticleStatusDTO} setNewsArticleStatusDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNewsArticleEmployeeStatus: async (tenantId: string, employeeId: string, articleId: string, setNewsArticleStatusDTO: SetNewsArticleStatusDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('setNewsArticleEmployeeStatus', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('setNewsArticleEmployeeStatus', 'employeeId', employeeId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('setNewsArticleEmployeeStatus', 'articleId', articleId)
            // verify required parameter 'setNewsArticleStatusDTO' is not null or undefined
            assertParamExists('setNewsArticleEmployeeStatus', 'setNewsArticleStatusDTO', setNewsArticleStatusDTO)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/news/articles/{articleId}/status`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setNewsArticleStatusDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {UpdateNewsArticleDTO} updateNewsArticleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticle: async (tenantId: string, articleId: string, updateNewsArticleDTO: UpdateNewsArticleDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateArticle', 'tenantId', tenantId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('updateArticle', 'articleId', articleId)
            // verify required parameter 'updateNewsArticleDTO' is not null or undefined
            assertParamExists('updateArticle', 'updateNewsArticleDTO', updateNewsArticleDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/news/articles/{articleId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNewsArticleDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewsApi - functional programming interface
 * @export
 */
export const NewsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NewsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add an attachment to a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {CreateNewsArticleAttachmentDTO} createNewsArticleAttachmentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAttachment(tenantId: string, articleId: string, createNewsArticleAttachmentDTO: CreateNewsArticleAttachmentDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentifierDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAttachment(tenantId, articleId, createNewsArticleAttachmentDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary create a new news article
         * @param {string} tenantId 
         * @param {CreateNewsArticleDTO} createNewsArticleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createArticle(tenantId: string, createNewsArticleDTO: CreateNewsArticleDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentifierDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createArticle(tenantId, createNewsArticleDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates a reaction on an article
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {NewsReactionCreateDTO} newsReactionCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createArticleReaction(tenantId: string, employeeId: string, articleId: string, newsReactionCreateDTO: NewsReactionCreateDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsReactionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createArticleReaction(tenantId, employeeId, articleId, newsReactionCreateDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a presigned upload link for a news article attachment
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAttachmentUploadLink(tenantId: string, articleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadLinkDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAttachmentUploadLink(tenantId, articleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a form POST upload link for uploading the benefit image. Refer to https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-post-example.html on how to implement the form POST.
         * @summary create a presigned upload link
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUploadLink(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadLinkDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUploadLink(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteArticle(tenantId: string, articleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteArticle(tenantId, articleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes a reaction on an article
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {NewsReactionDeleteDTO} newsReactionDeleteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteArticleReaction(tenantId: string, employeeId: string, articleId: string, newsReactionDeleteDTO: NewsReactionDeleteDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteArticleReaction(tenantId, employeeId, articleId, newsReactionDeleteDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an attachment from a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachment(tenantId: string, articleId: string, attachmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachment(tenantId, articleId, attachmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary expire a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expireNewsArticle(tenantId: string, articleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expireNewsArticle(tenantId, articleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary returns news article confirmation list in CSV format
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportNewsArticleConfirmation(tenantId: string, articleId: string, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportNewsArticleConfirmation(tenantId, articleId, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a certain news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {boolean} [withImage] if true, imageURL will be populated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticle(tenantId: string, articleId: string, withImage?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsArticleDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticle(tenantId, articleId, withImage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get reactions for an article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {string} [filter] Search by employee name, email or employee number
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleReactions(tenantId: string, articleId: string, filter?: string, page?: number, pageSize?: number, sortBy?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsReactionListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticleReactions(tenantId, articleId, filter, page, pageSize, sortBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all reactions for an article
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleReactionsUnpaginated(tenantId: string, employeeId: string, articleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsReactionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticleReactionsUnpaginated(tenantId, employeeId, articleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a certain news article with NewsArticleEmployeeStatus
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {boolean} [withImage] if true, imageURL will be populated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleWithEmployeeStatus(tenantId: string, employeeId: string, articleId: string, withImage?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsArticleDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticleWithEmployeeStatus(tenantId, employeeId, articleId, withImage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all news article confirmations for tenant
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listArticleConfirmations(tenantId: string, articleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsArticleConfirmationsListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listArticleConfirmations(tenantId, articleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all news article recipients for tenant
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listArticleRecipients(tenantId: string, articleId: string, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsArticleRecipientsListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listArticleRecipients(tenantId, articleId, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all news articles for tenant
         * @param {string} tenantId 
         * @param {'ACTIVE' | 'DRAFT' | 'EXPIRED'} [status] 
         * @param {boolean} [withImage] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listArticles(tenantId: string, status?: 'ACTIVE' | 'DRAFT' | 'EXPIRED', withImage?: boolean, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsArticlesListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listArticles(tenantId, status, withImage, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all news articles for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listArticlesByEmployee(tenantId: string, employeeId: string, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsArticlesListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listArticlesByEmployee(tenantId, employeeId, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary creates articleEmployee status
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {SetNewsArticleStatusDTO} setNewsArticleStatusDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setNewsArticleEmployeeStatus(tenantId: string, employeeId: string, articleId: string, setNewsArticleStatusDTO: SetNewsArticleStatusDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setNewsArticleEmployeeStatus(tenantId, employeeId, articleId, setNewsArticleStatusDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {UpdateNewsArticleDTO} updateNewsArticleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArticle(tenantId: string, articleId: string, updateNewsArticleDTO: UpdateNewsArticleDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArticle(tenantId, articleId, updateNewsArticleDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NewsApi - factory interface
 * @export
 */
export const NewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NewsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add an attachment to a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {CreateNewsArticleAttachmentDTO} createNewsArticleAttachmentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachment(tenantId: string, articleId: string, createNewsArticleAttachmentDTO: CreateNewsArticleAttachmentDTO, options?: any): AxiosPromise<IdentifierDTO> {
            return localVarFp.addAttachment(tenantId, articleId, createNewsArticleAttachmentDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a new news article
         * @param {string} tenantId 
         * @param {CreateNewsArticleDTO} createNewsArticleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArticle(tenantId: string, createNewsArticleDTO: CreateNewsArticleDTO, options?: any): AxiosPromise<IdentifierDTO> {
            return localVarFp.createArticle(tenantId, createNewsArticleDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a reaction on an article
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {NewsReactionCreateDTO} newsReactionCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArticleReaction(tenantId: string, employeeId: string, articleId: string, newsReactionCreateDTO: NewsReactionCreateDTO, options?: any): AxiosPromise<NewsReactionDTO> {
            return localVarFp.createArticleReaction(tenantId, employeeId, articleId, newsReactionCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a presigned upload link for a news article attachment
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttachmentUploadLink(tenantId: string, articleId: string, options?: any): AxiosPromise<UploadLinkDTO> {
            return localVarFp.createAttachmentUploadLink(tenantId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a form POST upload link for uploading the benefit image. Refer to https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-post-example.html on how to implement the form POST.
         * @summary create a presigned upload link
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadLink(tenantId: string, options?: any): AxiosPromise<UploadLinkDTO> {
            return localVarFp.createUploadLink(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticle(tenantId: string, articleId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteArticle(tenantId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a reaction on an article
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {NewsReactionDeleteDTO} newsReactionDeleteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticleReaction(tenantId: string, employeeId: string, articleId: string, newsReactionDeleteDTO: NewsReactionDeleteDTO, options?: any): AxiosPromise<void> {
            return localVarFp.deleteArticleReaction(tenantId, employeeId, articleId, newsReactionDeleteDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an attachment from a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(tenantId: string, articleId: string, attachmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAttachment(tenantId, articleId, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary expire a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireNewsArticle(tenantId: string, articleId: string, options?: any): AxiosPromise<void> {
            return localVarFp.expireNewsArticle(tenantId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns news article confirmation list in CSV format
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportNewsArticleConfirmation(tenantId: string, articleId: string, page?: number, pageSize?: number, options?: any): AxiosPromise<string> {
            return localVarFp.exportNewsArticleConfirmation(tenantId, articleId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a certain news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {boolean} [withImage] if true, imageURL will be populated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticle(tenantId: string, articleId: string, withImage?: boolean, options?: any): AxiosPromise<NewsArticleDTO> {
            return localVarFp.getArticle(tenantId, articleId, withImage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get reactions for an article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {string} [filter] Search by employee name, email or employee number
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleReactions(tenantId: string, articleId: string, filter?: string, page?: number, pageSize?: number, sortBy?: Array<string>, options?: any): AxiosPromise<NewsReactionListDTO> {
            return localVarFp.getArticleReactions(tenantId, articleId, filter, page, pageSize, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all reactions for an article
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleReactionsUnpaginated(tenantId: string, employeeId: string, articleId: string, options?: any): AxiosPromise<Array<NewsReactionDTO>> {
            return localVarFp.getArticleReactionsUnpaginated(tenantId, employeeId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a certain news article with NewsArticleEmployeeStatus
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {boolean} [withImage] if true, imageURL will be populated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleWithEmployeeStatus(tenantId: string, employeeId: string, articleId: string, withImage?: boolean, options?: any): AxiosPromise<NewsArticleDTO> {
            return localVarFp.getArticleWithEmployeeStatus(tenantId, employeeId, articleId, withImage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all news article confirmations for tenant
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listArticleConfirmations(tenantId: string, articleId: string, options?: any): AxiosPromise<NewsArticleConfirmationsListDTO> {
            return localVarFp.listArticleConfirmations(tenantId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all news article recipients for tenant
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listArticleRecipients(tenantId: string, articleId: string, page?: number, pageSize?: number, options?: any): AxiosPromise<NewsArticleRecipientsListDTO> {
            return localVarFp.listArticleRecipients(tenantId, articleId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all news articles for tenant
         * @param {string} tenantId 
         * @param {'ACTIVE' | 'DRAFT' | 'EXPIRED'} [status] 
         * @param {boolean} [withImage] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listArticles(tenantId: string, status?: 'ACTIVE' | 'DRAFT' | 'EXPIRED', withImage?: boolean, page?: number, pageSize?: number, options?: any): AxiosPromise<NewsArticlesListDTO> {
            return localVarFp.listArticles(tenantId, status, withImage, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all news articles for employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listArticlesByEmployee(tenantId: string, employeeId: string, page?: number, pageSize?: number, options?: any): AxiosPromise<NewsArticlesListDTO> {
            return localVarFp.listArticlesByEmployee(tenantId, employeeId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary creates articleEmployee status
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} articleId 
         * @param {SetNewsArticleStatusDTO} setNewsArticleStatusDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNewsArticleEmployeeStatus(tenantId: string, employeeId: string, articleId: string, setNewsArticleStatusDTO: SetNewsArticleStatusDTO, options?: any): AxiosPromise<void> {
            return localVarFp.setNewsArticleEmployeeStatus(tenantId, employeeId, articleId, setNewsArticleStatusDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a news article
         * @param {string} tenantId 
         * @param {string} articleId 
         * @param {UpdateNewsArticleDTO} updateNewsArticleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticle(tenantId: string, articleId: string, updateNewsArticleDTO: UpdateNewsArticleDTO, options?: any): AxiosPromise<void> {
            return localVarFp.updateArticle(tenantId, articleId, updateNewsArticleDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addAttachment operation in NewsApi.
 * @export
 * @interface NewsApiAddAttachmentRequest
 */
export interface NewsApiAddAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiAddAttachment
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiAddAttachment
     */
    readonly articleId: string

    /**
     * 
     * @type {CreateNewsArticleAttachmentDTO}
     * @memberof NewsApiAddAttachment
     */
    readonly createNewsArticleAttachmentDTO: CreateNewsArticleAttachmentDTO
}

/**
 * Request parameters for createArticle operation in NewsApi.
 * @export
 * @interface NewsApiCreateArticleRequest
 */
export interface NewsApiCreateArticleRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiCreateArticle
     */
    readonly tenantId: string

    /**
     * 
     * @type {CreateNewsArticleDTO}
     * @memberof NewsApiCreateArticle
     */
    readonly createNewsArticleDTO: CreateNewsArticleDTO
}

/**
 * Request parameters for createArticleReaction operation in NewsApi.
 * @export
 * @interface NewsApiCreateArticleReactionRequest
 */
export interface NewsApiCreateArticleReactionRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiCreateArticleReaction
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiCreateArticleReaction
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiCreateArticleReaction
     */
    readonly articleId: string

    /**
     * 
     * @type {NewsReactionCreateDTO}
     * @memberof NewsApiCreateArticleReaction
     */
    readonly newsReactionCreateDTO: NewsReactionCreateDTO
}

/**
 * Request parameters for createAttachmentUploadLink operation in NewsApi.
 * @export
 * @interface NewsApiCreateAttachmentUploadLinkRequest
 */
export interface NewsApiCreateAttachmentUploadLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiCreateAttachmentUploadLink
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiCreateAttachmentUploadLink
     */
    readonly articleId: string
}

/**
 * Request parameters for createUploadLink operation in NewsApi.
 * @export
 * @interface NewsApiCreateUploadLinkRequest
 */
export interface NewsApiCreateUploadLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiCreateUploadLink
     */
    readonly tenantId: string
}

/**
 * Request parameters for deleteArticle operation in NewsApi.
 * @export
 * @interface NewsApiDeleteArticleRequest
 */
export interface NewsApiDeleteArticleRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiDeleteArticle
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiDeleteArticle
     */
    readonly articleId: string
}

/**
 * Request parameters for deleteArticleReaction operation in NewsApi.
 * @export
 * @interface NewsApiDeleteArticleReactionRequest
 */
export interface NewsApiDeleteArticleReactionRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiDeleteArticleReaction
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiDeleteArticleReaction
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiDeleteArticleReaction
     */
    readonly articleId: string

    /**
     * 
     * @type {NewsReactionDeleteDTO}
     * @memberof NewsApiDeleteArticleReaction
     */
    readonly newsReactionDeleteDTO: NewsReactionDeleteDTO
}

/**
 * Request parameters for deleteAttachment operation in NewsApi.
 * @export
 * @interface NewsApiDeleteAttachmentRequest
 */
export interface NewsApiDeleteAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiDeleteAttachment
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiDeleteAttachment
     */
    readonly articleId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiDeleteAttachment
     */
    readonly attachmentId: string
}

/**
 * Request parameters for expireNewsArticle operation in NewsApi.
 * @export
 * @interface NewsApiExpireNewsArticleRequest
 */
export interface NewsApiExpireNewsArticleRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiExpireNewsArticle
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiExpireNewsArticle
     */
    readonly articleId: string
}

/**
 * Request parameters for exportNewsArticleConfirmation operation in NewsApi.
 * @export
 * @interface NewsApiExportNewsArticleConfirmationRequest
 */
export interface NewsApiExportNewsArticleConfirmationRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiExportNewsArticleConfirmation
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiExportNewsArticleConfirmation
     */
    readonly articleId: string

    /**
     * 
     * @type {number}
     * @memberof NewsApiExportNewsArticleConfirmation
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof NewsApiExportNewsArticleConfirmation
     */
    readonly pageSize?: number
}

/**
 * Request parameters for getArticle operation in NewsApi.
 * @export
 * @interface NewsApiGetArticleRequest
 */
export interface NewsApiGetArticleRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiGetArticle
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiGetArticle
     */
    readonly articleId: string

    /**
     * if true, imageURL will be populated
     * @type {boolean}
     * @memberof NewsApiGetArticle
     */
    readonly withImage?: boolean
}

/**
 * Request parameters for getArticleReactions operation in NewsApi.
 * @export
 * @interface NewsApiGetArticleReactionsRequest
 */
export interface NewsApiGetArticleReactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiGetArticleReactions
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiGetArticleReactions
     */
    readonly articleId: string

    /**
     * Search by employee name, email or employee number
     * @type {string}
     * @memberof NewsApiGetArticleReactions
     */
    readonly filter?: string

    /**
     * 
     * @type {number}
     * @memberof NewsApiGetArticleReactions
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof NewsApiGetArticleReactions
     */
    readonly pageSize?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof NewsApiGetArticleReactions
     */
    readonly sortBy?: Array<string>
}

/**
 * Request parameters for getArticleReactionsUnpaginated operation in NewsApi.
 * @export
 * @interface NewsApiGetArticleReactionsUnpaginatedRequest
 */
export interface NewsApiGetArticleReactionsUnpaginatedRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiGetArticleReactionsUnpaginated
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiGetArticleReactionsUnpaginated
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiGetArticleReactionsUnpaginated
     */
    readonly articleId: string
}

/**
 * Request parameters for getArticleWithEmployeeStatus operation in NewsApi.
 * @export
 * @interface NewsApiGetArticleWithEmployeeStatusRequest
 */
export interface NewsApiGetArticleWithEmployeeStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiGetArticleWithEmployeeStatus
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiGetArticleWithEmployeeStatus
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiGetArticleWithEmployeeStatus
     */
    readonly articleId: string

    /**
     * if true, imageURL will be populated
     * @type {boolean}
     * @memberof NewsApiGetArticleWithEmployeeStatus
     */
    readonly withImage?: boolean
}

/**
 * Request parameters for listArticleConfirmations operation in NewsApi.
 * @export
 * @interface NewsApiListArticleConfirmationsRequest
 */
export interface NewsApiListArticleConfirmationsRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiListArticleConfirmations
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiListArticleConfirmations
     */
    readonly articleId: string
}

/**
 * Request parameters for listArticleRecipients operation in NewsApi.
 * @export
 * @interface NewsApiListArticleRecipientsRequest
 */
export interface NewsApiListArticleRecipientsRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiListArticleRecipients
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiListArticleRecipients
     */
    readonly articleId: string

    /**
     * 
     * @type {number}
     * @memberof NewsApiListArticleRecipients
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof NewsApiListArticleRecipients
     */
    readonly pageSize?: number
}

/**
 * Request parameters for listArticles operation in NewsApi.
 * @export
 * @interface NewsApiListArticlesRequest
 */
export interface NewsApiListArticlesRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiListArticles
     */
    readonly tenantId: string

    /**
     * 
     * @type {'ACTIVE' | 'DRAFT' | 'EXPIRED'}
     * @memberof NewsApiListArticles
     */
    readonly status?: 'ACTIVE' | 'DRAFT' | 'EXPIRED'

    /**
     * 
     * @type {boolean}
     * @memberof NewsApiListArticles
     */
    readonly withImage?: boolean

    /**
     * 
     * @type {number}
     * @memberof NewsApiListArticles
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof NewsApiListArticles
     */
    readonly pageSize?: number
}

/**
 * Request parameters for listArticlesByEmployee operation in NewsApi.
 * @export
 * @interface NewsApiListArticlesByEmployeeRequest
 */
export interface NewsApiListArticlesByEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiListArticlesByEmployee
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiListArticlesByEmployee
     */
    readonly employeeId: string

    /**
     * 
     * @type {number}
     * @memberof NewsApiListArticlesByEmployee
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof NewsApiListArticlesByEmployee
     */
    readonly pageSize?: number
}

/**
 * Request parameters for setNewsArticleEmployeeStatus operation in NewsApi.
 * @export
 * @interface NewsApiSetNewsArticleEmployeeStatusRequest
 */
export interface NewsApiSetNewsArticleEmployeeStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiSetNewsArticleEmployeeStatus
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiSetNewsArticleEmployeeStatus
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiSetNewsArticleEmployeeStatus
     */
    readonly articleId: string

    /**
     * 
     * @type {SetNewsArticleStatusDTO}
     * @memberof NewsApiSetNewsArticleEmployeeStatus
     */
    readonly setNewsArticleStatusDTO: SetNewsArticleStatusDTO
}

/**
 * Request parameters for updateArticle operation in NewsApi.
 * @export
 * @interface NewsApiUpdateArticleRequest
 */
export interface NewsApiUpdateArticleRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsApiUpdateArticle
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof NewsApiUpdateArticle
     */
    readonly articleId: string

    /**
     * 
     * @type {UpdateNewsArticleDTO}
     * @memberof NewsApiUpdateArticle
     */
    readonly updateNewsArticleDTO: UpdateNewsArticleDTO
}

/**
 * NewsApi - object-oriented interface
 * @export
 * @class NewsApi
 * @extends {BaseAPI}
 */
export class NewsApi extends BaseAPI {
    /**
     * 
     * @summary Add an attachment to a news article
     * @param {NewsApiAddAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public addAttachment(requestParameters: NewsApiAddAttachmentRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).addAttachment(requestParameters.tenantId, requestParameters.articleId, requestParameters.createNewsArticleAttachmentDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a new news article
     * @param {NewsApiCreateArticleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public createArticle(requestParameters: NewsApiCreateArticleRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).createArticle(requestParameters.tenantId, requestParameters.createNewsArticleDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a reaction on an article
     * @param {NewsApiCreateArticleReactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public createArticleReaction(requestParameters: NewsApiCreateArticleReactionRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).createArticleReaction(requestParameters.tenantId, requestParameters.employeeId, requestParameters.articleId, requestParameters.newsReactionCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a presigned upload link for a news article attachment
     * @param {NewsApiCreateAttachmentUploadLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public createAttachmentUploadLink(requestParameters: NewsApiCreateAttachmentUploadLinkRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).createAttachmentUploadLink(requestParameters.tenantId, requestParameters.articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a form POST upload link for uploading the benefit image. Refer to https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-post-example.html on how to implement the form POST.
     * @summary create a presigned upload link
     * @param {NewsApiCreateUploadLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public createUploadLink(requestParameters: NewsApiCreateUploadLinkRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).createUploadLink(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a news article
     * @param {NewsApiDeleteArticleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public deleteArticle(requestParameters: NewsApiDeleteArticleRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).deleteArticle(requestParameters.tenantId, requestParameters.articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a reaction on an article
     * @param {NewsApiDeleteArticleReactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public deleteArticleReaction(requestParameters: NewsApiDeleteArticleReactionRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).deleteArticleReaction(requestParameters.tenantId, requestParameters.employeeId, requestParameters.articleId, requestParameters.newsReactionDeleteDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an attachment from a news article
     * @param {NewsApiDeleteAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public deleteAttachment(requestParameters: NewsApiDeleteAttachmentRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).deleteAttachment(requestParameters.tenantId, requestParameters.articleId, requestParameters.attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary expire a news article
     * @param {NewsApiExpireNewsArticleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public expireNewsArticle(requestParameters: NewsApiExpireNewsArticleRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).expireNewsArticle(requestParameters.tenantId, requestParameters.articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns news article confirmation list in CSV format
     * @param {NewsApiExportNewsArticleConfirmationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public exportNewsArticleConfirmation(requestParameters: NewsApiExportNewsArticleConfirmationRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).exportNewsArticleConfirmation(requestParameters.tenantId, requestParameters.articleId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a certain news article
     * @param {NewsApiGetArticleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getArticle(requestParameters: NewsApiGetArticleRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).getArticle(requestParameters.tenantId, requestParameters.articleId, requestParameters.withImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get reactions for an article
     * @param {NewsApiGetArticleReactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getArticleReactions(requestParameters: NewsApiGetArticleReactionsRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).getArticleReactions(requestParameters.tenantId, requestParameters.articleId, requestParameters.filter, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all reactions for an article
     * @param {NewsApiGetArticleReactionsUnpaginatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getArticleReactionsUnpaginated(requestParameters: NewsApiGetArticleReactionsUnpaginatedRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).getArticleReactionsUnpaginated(requestParameters.tenantId, requestParameters.employeeId, requestParameters.articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a certain news article with NewsArticleEmployeeStatus
     * @param {NewsApiGetArticleWithEmployeeStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getArticleWithEmployeeStatus(requestParameters: NewsApiGetArticleWithEmployeeStatusRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).getArticleWithEmployeeStatus(requestParameters.tenantId, requestParameters.employeeId, requestParameters.articleId, requestParameters.withImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all news article confirmations for tenant
     * @param {NewsApiListArticleConfirmationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public listArticleConfirmations(requestParameters: NewsApiListArticleConfirmationsRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).listArticleConfirmations(requestParameters.tenantId, requestParameters.articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all news article recipients for tenant
     * @param {NewsApiListArticleRecipientsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public listArticleRecipients(requestParameters: NewsApiListArticleRecipientsRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).listArticleRecipients(requestParameters.tenantId, requestParameters.articleId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all news articles for tenant
     * @param {NewsApiListArticlesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public listArticles(requestParameters: NewsApiListArticlesRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).listArticles(requestParameters.tenantId, requestParameters.status, requestParameters.withImage, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all news articles for employee
     * @param {NewsApiListArticlesByEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public listArticlesByEmployee(requestParameters: NewsApiListArticlesByEmployeeRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).listArticlesByEmployee(requestParameters.tenantId, requestParameters.employeeId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary creates articleEmployee status
     * @param {NewsApiSetNewsArticleEmployeeStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public setNewsArticleEmployeeStatus(requestParameters: NewsApiSetNewsArticleEmployeeStatusRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).setNewsArticleEmployeeStatus(requestParameters.tenantId, requestParameters.employeeId, requestParameters.articleId, requestParameters.setNewsArticleStatusDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a news article
     * @param {NewsApiUpdateArticleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public updateArticle(requestParameters: NewsApiUpdateArticleRequest, options?: AxiosRequestConfig) {
        return NewsApiFp(this.configuration).updateArticle(requestParameters.tenantId, requestParameters.articleId, requestParameters.updateNewsArticleDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
